export enum BOOKING_STATUS_CODE {
  ACTIVE = 1,
  CANCELLED = 2,
  FINISHED = 10,
  WAITING_TO_SIGN = 12,
}
